import { HeartBank } from "../../../managers/HeartBank.ts";
import template from "./hb-login.mjs";
import { render } from "lit-html";
import { HbMain } from "../../hb-main/hb-main.ts";
import {
    isInIframe,
    iframe,
    opener,
    getLanguage,
    redirect
} from "../../global.ts";

import { Modal } from "flowbite";
import type { ModalOptions, ModalInterface } from "flowbite";
import type { InstanceOptions } from "flowbite";

import Strings from "../../../models/Strings.json";
const strings: any = Strings;

export class HbLogin extends HTMLElement {
    private heartbank: HeartBank = new HeartBank();
    private modal: ModalInterface;
    private main = document.querySelector("hb-main") as HbMain;

    private login: HTMLElement;
    private form: HTMLFormElement;
    private email: HTMLInputElement;
    private message: HTMLParagraphElement;
    private passkey: HTMLAnchorElement;

    constructor() {
        super();
        render(template(null, getLanguage()), this);

        this.login = this.querySelector("#hb-login")!;
        this.form = this.querySelector("form")!;
        this.email = this.querySelector("#hb-login-email")!;
        this.message = this.querySelector("#hb-login-message")!;
        this.passkey = this.querySelector("#hb-login-passkey")!;

        const modalOptions: ModalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses:
                "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: true,
            onHide: () => {
                this.form.reset();
                this.message.textContent = "";
                //localStorage.removeItem("emailForLogin");
                //window.location.hash = "#";
            },
            onShow: () => {
                //console.log("modal is shown");
            },
            onToggle: () => {
                //console.log("modal has been toggled");
            }
        };

        // instance options object
        const instanceOptions: InstanceOptions = {
            id: "hb-login",
            override: true
        };

        this.modal = new Modal(this.login, modalOptions, instanceOptions);
    }

    connectedCallback() {
        if (this.heartbank.isPasskeySupported())
            this.passkey.classList.remove("hidden");
        else this.passkey.classList.add("hidden");

        this.form.addEventListener("submit", this.handleLogin.bind(this));
        this.handleEmailLink();

        this.heartbank.addAuthStateListener(async (user) => {
            render(template(user, getLanguage()), this);
            //this.main.showSpinner();

            const fragments = window.location.hash.split("/");
            if (fragments[1] === "login" || fragments[1] === "passkey") {
                if (user) {
                    if (opener) {
                        this.main.showSpinner();
                        const status = await this.heartbank.getCustomToken();
                        opener.postMessage(
                            {
                                action:
                                    status.color === "green"
                                        ? "success"
                                        : "error",
                                text: status.text,
                                token: status.token
                            },
                            "*"
                        );
                    } else if (isInIframe) {
                        this.main.showSpinner();
                        const status = await this.heartbank.getCustomToken();
                        iframe.postMessage(
                            {
                                action:
                                    status.color === "green"
                                        ? "success"
                                        : "error",
                                text: status.text,
                                token: status.token
                            },
                            "*"
                        );
                    } else {
                        const params = new URLSearchParams(
                            window.location.search
                        );
                        if (params.has("mode")) {
                            //render(template(user), this);
                        } else {
                            // logging in window
                            //alert(strings.login7[lang]); // TODO: later blocking redirect: show toast instead
                            //window.location.hash = "#"; //"#/account";
                            redirect("login", true);
                        }
                    }
                } else {
                    //render(template(user), this);
                }
            }
            //this.main.hideSpinner();
        });
    }

    show() {
        const fragments = window.location.hash.split("/");
        if (fragments[2] === "again") {
            this.message.textContent = strings.login5[getLanguage()];
            this.message.style.color = "red";
        }
        this.modal.show();
    }

    hide() {
        this.modal.hide();
    }

    //login endpoints: /again, /cross-device
    private async handleLogin(event: Event) {
        event.preventDefault();
        this.message.style.color = "orange";
        this.message.textContent = strings.login9[getLanguage()];
        this.main.showSpinner();

        const email = this.email.value.trim();
        const fragments = window.location.hash.split("/");
        let status;

        switch (fragments[2]) {
            case "cross-device":
                localStorage.setItem("emailForLogin", email);
                status = await this.heartbank.handleEmailLink();

                if (status.color === "green") {
                    const url = new URL(window.location.href);
                    url.hash = "#"; //"#/account";
                    url.search = "";
                    window.location.href = url.toString(); // bc does not auto refresh
                } else {
                    this.message.textContent = status.text;
                    this.message.style.color = status.color;
                }

                break;
            default:
                status = await this.heartbank.handleSendEmailLink(email);
                this.message.textContent = status.text;
                this.message.style.color = status.color;
        }

        //this.message.textContent = "";
        this.main.hideSpinner();
    }

    private async handleEmailLink() {
        const user = await this.heartbank.waitForAuth();
        const params = new URLSearchParams(window.location.search);

        if (params.get("mode") === "signIn") {
            this.main.showSpinner();
            const url = new URL(window.location.href);
            const status = await this.heartbank.handleEmailLink();
            if (user) {
                const fragments = window.location.hash.split("/");
                if (fragments[2] === "update") {
                    this.message.textContent = status.text;
                    this.message.style.color = status.color;
                    url.search = "";
                    window.history.replaceState(
                        {},
                        document.title,
                        url.toString()
                    );
                } else if (fragments[2] === "updateSuccess") {
                    url.search = "";
                    window.history.replaceState(
                        {},
                        document.title,
                        url.toString()
                    );
                    // continue at account page
                } else {
                    url.hash = "#"; //"#/account";
                    url.search = "";
                    window.location.href = url.toString(); //TODO: later show toast instead
                    //alert(strings.login8[language]); weird bug: blocks redirect
                }
            } else {
                switch (status.color) {
                    case "orange": // cross device
                        this.message.textContent = status.text;
                        this.message.style.color = "orange";
                        //url.search = ""; // need signature in url
                        url.hash = "#/login/cross-device";
                        window.history.replaceState(
                            {},
                            document.title,
                            url.toString()
                        );
                        render(template(null), this);
                        break;
                    case "green": // email link window
                        url.hash = "#"; //"#/account";
                        url.search = "";
                        window.location.href = url.toString(); // does not auto refresh
                        break;
                    case "red":
                        this.message.textContent = status.text;
                        this.message.style.color = "red";
                        url.search = "";
                        window.history.replaceState(
                            {},
                            document.title,
                            url.toString()
                        );
                        break;
                }
            }
            this.main.hideSpinner();
        }
    }
}
